import { AppModule } from 'app/module';
import { loadScript } from 'util/loadScript';
import { CONSENT_GROUPS, hasConsent } from 'util/consent';
import Template from './template.hbs';

const SCRIPT_ID = 'googleTagServices';
let slot = false;

export class BrandingSolutionAdCard extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        if (hasConsent(CONSENT_GROUPS.marketing)) {
            this.load();
        }
    }

    load() {
        loadScript('//www.googletagservices.com/tag/js/gpt.js', SCRIPT_ID);
        window.googleTagReady = () => {
            this.afterRender();
        };
    }

    domBindings() {
        return {
            container: '.m-brandingSolutionAdCard__container',
        };
    }

    getPropsFromDom() {
        if (this.dom.container) {
            return {
                active: true,
                id: this.dom.container.id,
                adUnitPath: this.dom.container.getAttribute('data-adunitpath'),
                width: parseInt(this.dom.container.getAttribute('data-width'), 10),
                height: parseInt(this.dom.container.getAttribute('data-height'), 10),
                targeting: {
                    keyword: this.dom.container.getAttribute('data-keyword'),
                    location: this.dom.container.getAttribute('data-location'),
                    jobfield: this.dom.container.getAttribute('data-jobfield'),
                    state: this.dom.container.getAttribute('data-state'),
                    employmenttype: this.dom.container.getAttribute('data-employmenttype'),
                    joblevel: this.dom.container.getAttribute('data-joblevel'),
                    isloggedin: (this.dom.container.getAttribute('data-isloggedin') === 'true'),
                    hasprofile: this.dom.container.getAttribute('data-hasprofile'),
                    hasjobalarm: (this.dom.container.getAttribute('data-hasjobalarm') === 'true'),
                },
            };
        }
        return {};
    }

    afterRender() {
        if (window.googletag && googletag.apiReady) {
            if (this.props.active) {
                this.renderAd();
            }
        }
    }

    renderAd() {
        googletag.cmd.push(() => {
            slot = googletag
                .defineSlot(this.props.adUnitPath, [this.props.width, this.props.height], this.props.id)
                .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            googletag.display(this.props.id);
            this.setTargeting();
        });
    }

    setTargeting() {
        googletag.cmd.push(() => {
            const targetingKeys = Object.keys(this.props.targeting);
            targetingKeys.forEach((targetingKey) => {
                const targetingValue = this.props.targeting[targetingKey];
                if (targetingKeys && targetingValue) {
                    slot.setTargeting(targetingKey, targetingValue);
                }
            });
        });
    }
}
